// Case study data — 6 populated with rich editorial content.
export const CASE_STUDIES = [
  {
    slug: "artisan-collective",
    index: "01",
    title: "Artisan Collective",
    subtitle: "A quiet marketplace for the makers who don't shout.",
    category: "Brand Identity",
    sector: "Retail / Craft",
    year: "2025",
    location: "Portland, OR",
    services: ["Brand Consulting", "Brand Identity", "Naming"],
    cover: "https://images.unsplash.com/photo-1763705857736-2b4f16a33758?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxtaW5pbWFsJTIwYnJhbmQlMjBpZGVudGl0eSUyMG1vY2t1cHxlbnwwfHx8fDE3ODQ4OTgzMzV8MA&ixlib=rb-4.1.0&q=85",
    aspect: "aspect-[4/5]",
    lead: "Artisan Collective wanted to feel less like a marketplace and more like a very good curator. We stripped the identity to a single voice, a single mark, and a single promise.",
    outcome: "Applications received from artisans tripled in Q1. Vendor retention up 68% after year one.",
    stat: "3.1×",
    statLabel: "Vendor applications, Q1",
    palette: ["#DFE0DA", "#141312", "#C55A2E"],
  },
  {
    slug: "bloom",
    index: "02",
    title: "Bloom",
    subtitle: "Everyday skincare, rewritten with restraint.",
    category: "Brand & Packaging",
    sector: "Beauty",
    year: "2024",
    location: "Copenhagen",
    services: ["Brand Strategy", "Visual Systems", "Packaging"],
    cover: "https://images.pexels.com/photos/36339062/pexels-photo-36339062.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    aspect: "aspect-[3/4]",
    lead: "Bloom sold beautiful products in beige-y packaging that whispered. We built a language that still whispers — but says something.",
    outcome: "DTC conversion increased 42%. Featured on the shelves of five flagship concept stores in Europe.",
    stat: "42%",
    statLabel: "Lift on DTC conversion",
    palette: ["#F1EDE4", "#2A2924", "#8A7E62"],
  },
  {
    slug: "northfield",
    index: "03",
    title: "Northfield Editorial",
    subtitle: "A magazine for founders who read.",
    category: "Editorial Design",
    sector: "Media",
    year: "2025",
    location: "New York",
    services: ["Brand Architecture", "Visual Systems"],
    cover: "https://images.unsplash.com/photo-1549298222-1c31e8915347?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHxlZGl0b3JpYWwlMjBmYXNoaW9uJTIwbWFnYXppbmUlMjBsYXlvdXQlMjBtb2NrdXB8ZW58MHx8fHwxNzg0ODk4MzQ4fDA&ixlib=rb-4.1.0&q=85",
    aspect: "aspect-[4/5]",
    lead: "Northfield had a strong voice and a weaker container. We rebuilt the architecture: masthead, section marks, cover system, and a quarterly print edition.",
    outcome: "Subscriber base doubled within eight months. Newsstand sell-through improved to 74%.",
    stat: "2×",
    statLabel: "Subscribers, 8 months",
    palette: ["#EFECE4", "#0F0E0C", "#6B5A3E"],
  },
  {
    slug: "aura",
    index: "04",
    title: "Aura",
    subtitle: "A minimalist skincare label built for founders who ship, not fuss.",
    category: "Brand & Packaging",
    sector: "Beauty / DTC",
    year: "2024",
    location: "London",
    services: ["Naming", "Brand Identity", "Packaging"],
    cover: "https://images.unsplash.com/photo-1698376621004-70ce754157d1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxwcmVtaXVtJTIwcGFja2FnaW5nJTIwZGVzaWduJTIwbW9ja3VwfGVufDB8fHx8MTc4NDg5ODMzNXww&ixlib=rb-4.1.0&q=85",
    aspect: "aspect-[3/4]",
    lead: "Aura's founder spent months trying to say 'clean, modern, honest' in six SKUs. We wrote it in one wordmark and let the shelf do the rest.",
    outcome: "Wholesale accounts signed 3× faster. Sold into Liberty London within four months.",
    stat: "4mo",
    statLabel: "From launch to Liberty London",
    palette: ["#F7F5EE", "#111110", "#A7A29A"],
  },
  {
    slug: "chapter",
    index: "05",
    title: "Chapter Coffee",
    subtitle: "A boutique roastery that reads like a small press.",
    category: "Boutique Branding",
    sector: "Hospitality / F&B",
    year: "2023",
    location: "Melbourne",
    services: ["Brand Strategy", "Brand Identity", "Visual Systems"],
    cover: "https://images.unsplash.com/photo-1605711599412-775918dbe770?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwyfHxtaW5pbWFsaXN0JTIwYm91dGlxdWUlMjBjb2ZmZWUlMjBiYWclMjBtb2NrdXB8ZW58MHx8fHwxNzg0ODk4MzQ4fDA&ixlib=rb-4.1.0&q=85",
    aspect: "aspect-[4/5]",
    lead: "Chapter was tired of coffee bags that looked like every other coffee bag. We treated each origin like a first edition — with a spine, a chapter number, and a real editorial.",
    outcome: "Wholesale doubled. Two new cafés opened without discounting.",
    stat: "2.0×",
    statLabel: "Wholesale growth, y/y",
    palette: ["#EDE6D8", "#1B1917", "#7A5A2E"],
  },
  {
    slug: "kinetix",
    index: "06",
    title: "Kinetix",
    subtitle: "A visual system for a performance-eyewear brand that refused to look sporty.",
    category: "Visual System",
    sector: "Wearables / Fashion",
    year: "2025",
    location: "Milan",
    services: ["Positioning", "Brand Architecture", "Visual Systems"],
    cover: "https://images.unsplash.com/photo-1590102426275-8d1c367070d3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxtaW5pbWFsJTIwYnJhbmQlMjBpZGVudGl0eSUyMG1vY2t1cHxlbnwwfHx8fDE3ODQ4OTgzMzV8MA&ixlib=rb-4.1.0&q=85",
    aspect: "aspect-[3/4]",
    lead: "Kinetix asked for 'performance without the neon.' We gave them a system that could sit next to Prada without apologising to Nike.",
    outcome: "40% faster enterprise deal-closing after brand refresh. Direct-to-boutique channel opened.",
    stat: "40%",
    statLabel: "Faster deal-closing",
    palette: ["#F0EEE8", "#0B0B0A", "#3C4A44"],
  },
];

export function findCaseStudy(slug) {
  return CASE_STUDIES.find((c) => c.slug === slug);
}
